export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string[];
  category: string;
  categorySlug: string;
  author: string;
  authorAvatar: string;
  publishedAt: string;
  readTime: number;
  imageUrl: string;
  tags: string[];
  featured: boolean;
  trending: boolean;
}

export const categories = [
  { name: '时尚潮流', slug: 'fashion-trend', icon: 'ri-t-shirt-line', description: '探索最新时尚趋势，发现属于你的穿搭灵感' },
  { name: '美食探店', slug: 'food-discovery', icon: 'ri-restaurant-line', description: '走遍各地，寻找最地道的美食体验' },
  { name: '情感故事', slug: 'emotion-story', icon: 'ri-heart-line', description: '温暖治愈的情感分享，聆听内心的声音' },
  { name: '生活方式', slug: 'lifestyle', icon: 'ri-sun-line', description: '打造精致生活，分享日常中的美好瞬间' },
  { name: '旅行日记', slug: 'travel-diary', icon: 'ri-earth-line', description: '用脚步丈量世界，记录旅途中的风景' },
  { name: '美妆护肤', slug: 'beauty-skincare', icon: 'ri-magic-line', description: '科学护肤与潮流美妆的实用指南' },
];

export const articles: Article[] = [
  {
    id: '1',
    slug: '2024-autumn-winter-fashion-trends',
    title: '2025秋冬时尚趋势：温暖色调与层叠穿搭的艺术',
    excerpt: '随着秋冬季节的到来，时尚界迎来了新一轮的流行风潮。从温暖的焦糖色到复古的格纹元素，今年的秋冬穿搭关键词是"舒适与个性并存"。让我们一起探索这一季最值得关注的五大流行趋势。',
    content: [
      '当第一片落叶飘落，衣橱里的短袖和薄裙也逐渐被收起。秋冬季节的穿搭，总让人充满期待——那种被柔软面料包裹的温暖感，是其他季节无法替代的。',
      '今年秋冬，时尚圈呈现出一种回归本质的趋势。设计师们不再追求过于夸张的造型，而是将焦点放在了面料质感、剪裁细节和色彩搭配上。',
      '焦糖色系无疑是本季的主角。从深棕到奶茶色，再到温暖的橘棕调，这些颜色不仅百搭，还能轻松营造出高级感。一件焦糖色的羊毛大衣，搭配同色系的针织围巾，走在秋日街头，仿佛一幅温暖的油画。',
      '除了色彩，层叠穿搭也是今年的关键词。衬衫外搭针织马甲，再披上一件oversized风衣——这种"洋葱式"穿法不仅应对温差，还能展现搭配功力。关键是要注意不同材质之间的对比与呼应。',
      '配饰方面，今年流行的是夸张但不浮夸的风格。大号的羊毛围巾、质感十足的皮质手套、以及复古的圆形墨镜，都能为整体造型加分。记住，配饰是展现个性的最佳方式。',
      '无论时尚如何变迁，最重要的永远是穿出属于自己的风格。这个秋冬，不妨大胆尝试，找到最适合你的那套搭配法则。'
    ],
    category: '时尚潮流',
    categorySlug: 'fashion-trend',
    author: '林小桃',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20young%20Chinese%20woman%20portrait%20with%20warm%20smile%20soft%20natural%20lighting%20peach%20toned%20background%20minimal%20style%20editorial%20quality&width=120&height=120&seq=author-lin-01&orientation=squarish',
    publishedAt: '2025-08-05',
    readTime: 8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Autumn%20winter%20fashion%20layout%20with%20warm%20toned%20knitwear%20coat%20scarf%20on%20minimal%20cream%20background%20soft%20natural%20light%20elegant%20composition%20editorial%20style%20warm%20caramel%20brown%20tones&width=1200&height=675&seq=article-fashion-01&orientation=landscape',
    tags: ['秋冬穿搭', '时尚趋势', '焦糖色系', '层叠穿搭'],
    featured: true,
    trending: true,
  },
  {
    id: '2',
    slug: 'hidden-gem-dessert-shops-shanghai',
    title: '上海隐秘甜品店地图：这5家宝藏小店让你甜到心里',
    excerpt: '告别千篇一律的连锁甜品店，我们走遍上海的大街小巷，为你挖掘出5家真正值得打卡的隐秘甜品店。从法式慕斯到日式和果子，每一家都有独特的甜蜜故事。',
    content: [
      '在上海这座国际化大都市里，甜品早已不只是餐后的点缀，而成为了一种生活态度。然而，真正让人心动的甜品店，往往藏在那些不起眼的街角巷尾。',
      '第一家推荐的是位于武康路的"蜜语"，这家店的招牌是法式慕斯蛋糕。店主曾在巴黎学习甜点制作多年，回国后将法式甜品的精致与东方口味巧妙融合。推荐尝试他们的玫瑰荔枝慕斯，甜而不腻，入口即化。',
      '如果你偏爱日式甜点，那就一定不能错过藏在安福路深处的"森の菓子"。这家小店主打手工和果子，每一枚都是店主亲手制作。特别推荐他们的抹茶大福，外皮软糯，内馅浓郁，配上一杯手冲煎茶，简直是完美的下午茶组合。',
      '当然，如果你追求的是纯粹的甜蜜快乐，富民路上的"糖份研究所"绝对是你的不二之选。这里的招牌提拉米苏被誉为"上海最好吃的提拉米苏"——浓郁的咖啡香、绵密的奶油、恰到好处的酒香，让人一口接一口停不下来。',
      '甜品，不只是食物，更是一种心情。希望这份甜点地图，能给你的生活带来更多的甜蜜时刻。'
    ],
    category: '美食探店',
    categorySlug: 'food-discovery',
    author: '甜小喵',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Friendly%20young%20Chinese%20woman%20portrait%20with%20bright%20smile%20warm%20peach%20background%20clean%20editorial%20style&width=120&height=120&seq=author-tian-01&orientation=squarish',
    publishedAt: '2025-08-03',
    readTime: 10,
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20dessert%20display%20with%20colorful%20macarons%20cake%20tiramisu%20on%20minimal%20cream%20background%20soft%20warm%20lighting%20elegant%20food%20photography%20pastel%20tones&width=1200&height=675&seq=article-food-01&orientation=landscape',
    tags: ['甜品探店', '上海美食', '下午茶', '宝藏店铺'],
    featured: true,
    trending: true,
  },
  {
    id: '3',
    slug: 'heal-yourself-emotional-growth',
    title: '学会与自己和解：30岁后我领悟到的5个情感真相',
    excerpt: '成长是一个不断认识自己的过程。30岁后，我逐渐明白了关于感情、关于自我的几个真相。这些感悟或许不完美，但真实而温暖，希望能给正在迷茫的你一些力量。',
    content: [
      '二十多岁的时候，我们总以为爱情就是全部。为了一个人可以放弃整个世界，为了一段感情可以辗转反侧到天明。但步入30岁后，我开始慢慢明白——有些真相，只有经历过才能领悟。',
      '第一个真相是：没有人能完全理解你，包括你自己。我们常常期待伴侣能够读懂自己的每一个眼神、每一个沉默，但事实上，表达比期待更重要。学会说出自己的感受，是成年人的必修课。',
      '第二个真相：孤独是常态，不是失败。一个人的时候，不是可怜，而是与自己相处的最好时光。学会享受独处，比学会社交更加重要。',
      '第三个真相：放下不等于放弃。有些事情，努力过了却依然没有结果，这时候放手不是软弱，而是对自己的一种温柔。人生那么长，不值得在原地打转。',
      '第四个真相：你的价值不由别人定义。无论是单身还是恋爱中，你的价值都不应该与他人的评价挂钩。学会欣赏自己，是最重要的一课。',
      '最后一个真相：所有的相遇都有意义。那些让你心碎的人、让你成长的经历，最终都会变成你生命中的养分。感谢每一段相遇，然后继续向前走。',
      '希望每一个正在阅读这篇文章的你，都能温柔地对待自己。因为，你值得被这世界温柔以待。'
    ],
    category: '情感故事',
    categorySlug: 'emotion-story',
    author: '温暖桃',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Gentle%20young%20Chinese%20woman%20portrait%20with%20soft%20expression%20warm%20lighting%20peach%20toned%20background%20minimal%20style&width=120&height=120&seq=author-wen-01&orientation=squarish',
    publishedAt: '2025-08-01',
    readTime: 7,
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20scene%20with%20cup%20of%20tea%20soft%20blanket%20open%20book%20by%20window%20soft%20natural%20lighting%20peach%20cream%20tones%20peaceful%20atmosphere%20editorial%20quality&width=1200&height=675&seq=article-emotion-01&orientation=landscape',
    tags: ['情感成长', '自我和解', '30岁感悟', '治愈系'],
    featured: false,
    trending: true,
  },
  {
    id: '4',
    slug: 'minimalist-morning-routine',
    title: '极简主义者的晨间仪式：6个习惯开启高效一天',
    excerpt: '好的早晨决定好的一天。作为一个践行极简生活三年的实践者，我想分享我的晨间仪式——不需要复杂的步骤，只需6个小习惯，就能让你的一天充满能量和方向感。',
    content: [
      '在快节奏的都市生活中，早晨往往是最匆忙的时刻。闹钟响了又按、匆匆忙忙洗漱、随便抓一件衣服就出门——这是我们大多数人的日常。但其实，只要调整几个小习惯，清晨就能变成一天中最美好的时光。',
      '第一个习惯：起床后喝一杯温水。这个看似简单的动作，能在3分钟内唤醒你的身体。我会在杯子里加入一片柠檬，清新的味道让人瞬间精神起来。',
      '第二个习惯：不要马上看手机。给自己15分钟的"无屏幕时间"，让大脑从睡眠状态自然过渡到清醒状态。这段时间可以用来拉伸、冥想或者只是静静地坐着。',
      '第三个习惯：整理床铺。这只需要2分钟，但能让你的卧室立刻变得整洁有序，也会给你一种"已经完成了一件事"的成就感。',
      '第四个习惯：写下今天的三个目标。不需要是宏大的计划，哪怕是"给妈妈打个电话"或者"读完一本书的第三章"都可以。让一天有清晰的方向。',
      '第五个习惯：享受一顿不赶时间的早餐。哪怕只有10分钟，坐下来好好吃一顿早餐，会让你的一整天都更有节奏感。',
      '最后一个习惯：出门前对着镜子微笑。听起来有点傻，但真的有效。给自己一个肯定的微笑，带着好心情出门。',
      '极简不是少，而是专注真正重要的事。希望这些小小的晨间仪式，能给你的生活带来一些改变。'
    ],
    category: '生活方式',
    categorySlug: 'lifestyle',
    author: '桃小简',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Calm%20young%20Chinese%20woman%20portrait%20minimalist%20style%20warm%20natural%20lighting%20cream%20background%20clean%20editorial%20look&width=120&height=120&seq=author-tao-01&orientation=squarish',
    publishedAt: '2025-07-28',
    readTime: 6,
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20morning%20scene%20with%20bed%20sunlight%20cup%20of%20water%20notebook%20on%20wooden%20desk%20warm%20cream%20tones%20soft%20natural%20light%20peaceful%20atmosphere&width=1200&height=675&seq=article-lifestyle-01&orientation=landscape',
    tags: ['极简生活', '晨间仪式', '效率提升', '生活习惯'],
    featured: true,
    trending: false,
  },
  {
    id: '5',
    slug: 'kyoto-hidden-temples-guide',
    title: '京都小众寺院巡礼：避开人潮，寻找真正的禅意之美',
    excerpt: '厌倦了清水寺和金阁寺的人山人海？这篇指南带你走进京都那些鲜为人知的隐秘寺院，在静谧中感受千年古都的禅意与宁静。',
    content: [
      '京都，这座千年古都，拥有超过1600座寺庙。然而，大多数游客只会在清水寺、金阁寺等知名景点挤破头。如果你想要体验真正的京都禅意，这些隐藏在街巷深处的小寺院，才是最值得探访的地方。',
      '首先要推荐的是位于东山区的"青莲院"。这里不像清水寺那样喧嚣，却有京都最美的枯山水庭院之一。坐在廊下，静静地看着庭院中的石子纹路，仿佛时间都慢了下来。',
      '接下来是岚山附近的"祇王寺"。这座小小的寺院隐藏在竹林深处，青苔覆盖的地面和古朴的木造建筑，给人一种穿越时空的错觉。传闻这里曾是《平家物语》中祇王隐居的地方。',
      '如果你喜欢茶道文化，一定不能错过大德寺的"高桐院"。这里的茶室被誉为京都最美的茶室之一，需要提前预约才能参观。但当你坐在茶室里，看着窗外的竹林摇曳，品一口抹茶，一切等待都值得。',
      '旅行不只是打卡，更是一种与自己对话的方式。在京都的这些隐秘寺院里，你会找到内心的那份宁静。'
    ],
    category: '旅行日记',
    categorySlug: 'travel-diary',
    author: '远行桃',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Adventurous%20young%20Chinese%20woman%20portrait%20outdoor%20natural%20light%20warm%20tone%20cream%20background%20editorial%20quality&width=120&height=120&seq=author-yuan-01&orientation=squarish',
    publishedAt: '2025-07-25',
    readTime: 9,
    imageUrl: 'https://readdy.ai/api/search-image?query=Kyoto%20traditional%20Japanese%20temple%20with%20zen%20garden%20moss%20covered%20stones%20bamboo%20trees%20soft%20warm%20morning%20light%20peaceful%20atmosphere%20cream%20green%20tones&width=1200&height=675&seq=article-travel-01&orientation=landscape',
    tags: ['京都旅行', '小众景点', '日本文化', '禅意'],
    featured: false,
    trending: true,
  },
  {
    id: '6',
    slug: 'skincare-myths-science-explained',
    title: '护肤谣言粉碎机：这7个"常识"其实一直在伤害你的皮肤',
    excerpt: '"护肤品要拍打吸收"、"出油是因为缺水"、"天然成分最安全"——这些护肤圈流传的"常识"真的对吗？今天我们请到了皮肤科医生，用科学来一一击破这些护肤谣言。',
    content: [
      '护肤圈大概是谣言最多的地方之一了。从"拍打能促进吸收"到"出油是因为缺水"，各种似是而非的说法让人眼花缭乱。今天我们就来一个一个说清楚。',
      '谣言一："护肤品要拍打吸收"。真相是：拍打并不会帮助吸收，反而可能刺激皮肤、破坏毛细血管。正确的做法是轻轻按压，让产品自然吸收。',
      '谣言二："出油是因为皮肤缺水"。这大概是流传最广的护肤谣言了。事实上，出油是由皮脂腺分泌决定的，与皮肤含水量没有直接关系。油皮需要的是控油，而不是疯狂补水。',
      '谣言三："天然成分最安全"。天然不等于安全，人工合成的成分也不等于有害。很多天然成分同样可能引起过敏，而许多合成成分经过了严格的安全测试。关键是看成分本身，而不是来源。',
      '谣言四："防晒只有夏天才需要"。紫外线不分季节，UVA甚至可以穿透玻璃。防晒是全年无休的事，阴天和冬天同样需要。',
      '护肤这件事，最重要的不是跟风，而是了解自己的肤质，选择真正适合自己的产品。希望这篇辟谣文章能帮你少走一些弯路。'
    ],
    category: '美妆护肤',
    categorySlug: 'beauty-skincare',
    author: '桃小美',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Stylish%20young%20Chinese%20woman%20portrait%20with%20natural%20makeup%20warm%20lighting%20peach%20background%20editorial%20quality&width=120&height=120&seq=author-mei-01&orientation=squarish',
    publishedAt: '2025-07-22',
    readTime: 8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimal%20skincare%20products%20arrangement%20on%20cream%20marble%20surface%20with%20natural%20flowers%20soft%20warm%20lighting%20clean%20aesthetic%20editorial%20quality%20peach%20white%20tones&width=1200&height=675&seq=article-beauty-01&orientation=landscape',
    tags: ['护肤科普', '护肤谣言', '科学护肤', '皮肤健康'],
    featured: true,
    trending: false,
  },
  {
    id: '7',
    slug: 'capsule-wardrobe-spring-summer',
    title: '春夏胶囊衣橱指南：35件单品搞定整个季节',
    excerpt: '每天早上站在衣柜前发呆，不知道穿什么？试试胶囊衣橱吧！只需35件精心挑选的单品，就能组合出上百套不同的搭配。这个春夏，让你的衣橱变得轻盈高效。',
    content: [
      '打开衣柜，满眼都是衣服，却总觉得没衣服穿——这是不是你的日常？胶囊衣橱的理念就是解决这个问题：用少量的高品质基础单品，搭配出无限可能。',
      '春夏胶囊衣橱的核心单品：3件基础T恤（白、黑、条纹）、2件衬衫（一件白色棉质、一件牛仔）、2条牛仔裤（一深一浅）、1条黑色阔腿裤、1条A字裙、2件外套（一件西装、一件牛仔夹克）、3件连衣裙（小黑裙、碎花裙、衬衫裙），再加上鞋子、包包和配饰，总共35件。',
      '搭配的关键是"三七法则"：70%的基础款+30%的个性款。基础款负责百搭，个性款负责出彩。比如一件基础白T配一条亮色阔腿裤，简单却不单调。',
      '胶囊衣橱的好处不只是省钱省空间，更重要的是减少了每天的选择困难。当你衣柜里每一件都是精心挑选的单品时，穿搭就变成了一件享受的事。',
      '这个春夏，不妨试试胶囊衣橱，让你的穿衣风格变得更加从容自信。'
    ],
    category: '时尚潮流',
    categorySlug: 'fashion-trend',
    author: '林小桃',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20young%20Chinese%20woman%20portrait%20with%20warm%20smile%20soft%20natural%20lighting%20peach%20toned%20background%20minimal%20style%20editorial%20quality&width=120&height=120&seq=author-lin-01&orientation=squarish',
    publishedAt: '2025-07-20',
    readTime: 7,
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20capsule%20wardrobe%20layout%20with%20neutral%20toned%20clothing%20items%20flat%20lay%20on%20cream%20background%20clean%20organized%20warm%20lighting%20aesthetic%20editorial&width=1200&height=675&seq=article-fashion-02&orientation=landscape',
    tags: ['胶囊衣橱', '穿搭指南', '极简时尚', '春夏搭配'],
    featured: false,
    trending: false,
  },
  {
    id: '8',
    slug: 'homemade-matcha-desserts',
    title: '抹茶控的终极福利：5款在家就能做的日式抹茶甜品',
    excerpt: '不用去昂贵的甜品店，在家也能做出媲美专业水准的抹茶甜品。从抹茶千层到抹茶熔岩蛋糕，这5款零失败配方，让你变身朋友圈里的甜品达人。',
    content: [
      '作为一个资深抹茶控，我可以负责任地说：世界上没有比一碗抹茶更治愈的东西了。如果有，那就是抹茶做的甜品。今天分享5款在家就能轻松制作的抹茶甜品，每一款都经过反复试验，保证零失败。',
      '第一款：抹茶巴斯克芝士蛋糕。这款蛋糕的特点是外焦里嫩，制作起来出乎意料地简单。只需将奶油奶酪、鸡蛋、糖、淡奶油和抹茶粉混合搅拌，倒入模具烤制即可。重点是抹茶粉要先用少量热水调开，避免结块。',
      '第二款：抹茶千层蛋糕。看起来高端实际上只需要耐心。一张张薄如蝉翼的抹茶可丽饼，夹上轻盈的抹茶奶油，层层叠叠，冷藏后切片，颜值和口感都在线。',
      '第三款：抹茶熔岩蛋糕。切开的一瞬间，绿色的抹茶熔岩缓缓流出——这就是甜品的终极浪漫。关键是要控制好烤制时间，多一分钟可能就没了流心效果。',
      '第四款：抹茶雪媚娘。软糯Q弹的外皮包裹着香浓的抹茶奶油馅，一口一个，根本停不下来。',
      '第五款：抹茶拿铁。最简单也是最快手的抹茶饮品。重点在于打抹茶的手法——要用茶筅以"W"字形快速搅打，直到表面出现细腻的泡沫。',
      '甜品制作的过程本身就是一种治愈。希望这些抹茶配方能给你的生活带来一些甜。'
    ],
    category: '美食探店',
    categorySlug: 'food-discovery',
    author: '甜小喵',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Friendly%20young%20Chinese%20woman%20portrait%20with%20bright%20smile%20warm%20peach%20background%20clean%20editorial%20style&width=120&height=120&seq=author-tian-01&orientation=squarish',
    publishedAt: '2025-07-18',
    readTime: 9,
    imageUrl: 'https://readdy.ai/api/search-image?query=Matcha%20desserts%20collection%20green%20tea%20cake%20mochi%20latte%20on%20cream%20background%20soft%20warm%20lighting%20elegant%20food%20photography%20minimal%20style&width=1200&height=675&seq=article-food-02&orientation=landscape',
    tags: ['抹茶甜品', '家庭烘焙', '日式甜点', '自制美食'],
    featured: false,
    trending: true,
  },
  {
    id: '9',
    slug: 'long-distance-relationship-survival-guide',
    title: '异地恋生存指南：距离从来不是感情的终点',
    excerpt: '异地恋真的那么可怕吗？作为一个经历过三年异地恋并且最终修成正果的人，我想分享一些真实的经验和建议。距离从来不是感情的终点，它只是考验真心的过程。',
    content: [
      '第一次听说我们要异地的时候，我也和所有人一样恐慌。电话能代替拥抱吗？视频能感受到体温吗？但三年后的今天，我想说：异地恋没有想象中那么可怕，甚至可能让你们的感情更加牢固。',
      '第一点建议：建立固定的沟通节奏。不需要24小时在线，但每天的早安晚安和睡前一通电话，能让彼此感觉对方就在身边。周六是我们雷打不动的"约会日"，视频一起看电影、一起吃饭，虽然隔着屏幕，但仪式感很重要。',
      '第二点建议：吵架不过夜。异地恋最怕的就是冷战。因为看不见对方的表情，误会很容易升级。我们的约定是：不管多生气，当天的事情当天解决。有时候一个电话吵完，反而比微信打字更高效。',
      '第三点建议：为见面制造期待。每次见面我们都当成旅行来计划。选一个中间城市，或者去对方所在的城市探险。这种期待感，让每个月的等待都变得不那么难熬。',
      '第四点建议：要有共同的未来计划。异地最怕的是看不到尽头。当我们确定了一个"结束异地"的时间节点，所有的等待都变得有了意义。',
      '异地恋很难，但值得。因为经历过距离考验的感情，会更加珍贵。'
    ],
    category: '情感故事',
    categorySlug: 'emotion-story',
    author: '温暖桃',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Gentle%20young%20Chinese%20woman%20portrait%20with%20soft%20expression%20warm%20lighting%20peach%20toned%20background%20minimal%20style&width=120&height=120&seq=author-wen-01&orientation=squarish',
    publishedAt: '2025-07-15',
    readTime: 8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20phones%20connected%20by%20string%20on%20warm%20cream%20background%20soft%20romantic%20lighting%20minimal%20composition%20emotional%20editorial%20style%20peach%20tones&width=1200&height=675&seq=article-emotion-02&orientation=landscape',
    tags: ['异地恋', '情感指南', '恋爱建议', '亲密关系'],
    featured: false,
    trending: false,
  },
  {
    id: '10',
    slug: 'digital-detox-weekend-guide',
    title: '周末数字排毒计划：48小时远离手机，找回生活的真实触感',
    excerpt: '你有多久没有完整地度过一个不刷手机的周末了？这个周末，试试我们的"数字排毒计划"，用48小时远离电子屏幕，重新感受生活的温度和质感。',
    content: [
      '上周六早上，我像往常一样醒来，第一件事就是摸手机。在刷了40分钟短视频后，我突然意识到——我已经很久没有在周末真正地"生活"过了。于是，我决定尝试一个大胆的实验：周末48小时数字排毒。',
      '周五晚上：把所有社交App的通知关掉，把手机调成勿扰模式，放在抽屉里。最初的不适感很强烈，手会不自觉地想去摸手机。我选择翻开了一本买了很久但一直没看的纸质书。',
      '周六上午：没有手机的闹钟，但我7点就自然醒了。做了一个悠闲的早餐——煎蛋、牛油果吐司、手冲咖啡——每一口都吃得很认真，而不是边刷手机边吃东西。',
      '周六下午：出门散步，不带手机。走在公园里，我第一次注意到原来小区门口那棵银杏树已经开始变黄了，邻居家的猫喜欢趴在围墙上晒太阳——这些细节以前都被手机屏幕遮住了。',
      '周日上午：去了菜市场，用现金买了一堆新鲜食材。和卖菜阿姨聊了几句，她说最近天气好，青菜长得特别好。这种人与人之间的自然交流，是外卖App永远给不了的。',
      '周日下午：约了朋友在咖啡馆见面。没有手机的干扰，我们的聊天格外深入。从工作聊到理想，从烦恼聊到未来，两个小时一晃就过去了。',
      '48小时实验结束后，我发现自己并没有错过什么重要的事，反而收获了一个真实、宁静的周末。也许我们需要的，不是更多的信息，而是更少的噪音。'
    ],
    category: '生活方式',
    categorySlug: 'lifestyle',
    author: '桃小简',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Calm%20young%20Chinese%20woman%20portrait%20minimalist%20style%20warm%20natural%20lighting%20cream%20background%20clean%20editorial%20look&width=120&height=120&seq=author-tao-01&orientation=squarish',
    publishedAt: '2025-07-12',
    readTime: 7,
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20weekend%20scene%20with%20cup%20of%20coffee%20open%20book%20fresh%20flowers%20on%20wooden%20table%20by%20window%20soft%20natural%20lighting%20warm%20cream%20tones%20peaceful&width=1200&height=675&seq=article-lifestyle-02&orientation=landscape',
    tags: ['数字排毒', '慢生活', '周末计划', '生活品质'],
    featured: true,
    trending: false,
  },
  {
    id: '11',
    slug: 'dali-travel-photo-guide',
    title: '大理旅拍全攻略：摄影师私藏的7个绝美取景地',
    excerpt: '大理，一个被无数人拍过却总能拍出新意的地方。作为常驻大理的自由摄影师，我将分享7个不在攻略书上的绝美取景地，让你拍出不一样的大理。',
    content: [
      '大理大概是国内最适合拍照的城市之一了。苍山洱海、白族民居、古城小巷——每一个角落都自带滤镜。但如果你厌倦了那些"网红打卡点"，这篇攻略就是为你准备的。',
      '第一个取景地：喜洲古镇的稻田。大多数人只知道喜洲的转角楼，却不知道镇外的稻田才是真正的宝藏。每年秋天，金黄色的稻田与远处的苍山构成一幅天然油画，日落前的一小时是最佳拍摄时间。',
      '第二个取景地：海舌生态公园的枯树。这棵孤独的树矗立在洱海中，无论什么季节都有不同的美感。冬天的时候，水面平静如镜，树的倒影清晰可见，画面极具感染力。',
      '第三个取景地：挖色镇的黄昏码头。这里游客稀少，每到傍晚，当地渔民会在这里收网。金色的夕阳洒在洱海上，配上渔民劳作的身影，充满了生活气息。',
      '拍摄大理，不需要太多的技巧，因为这里本身就已经足够美。你只需要带上发现美的眼睛，和一颗愿意慢下来的心。'
    ],
    category: '旅行日记',
    categorySlug: 'travel-diary',
    author: '远行桃',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Adventurous%20young%20Chinese%20woman%20portrait%20outdoor%20natural%20light%20warm%20tone%20cream%20background%20editorial%20quality&width=120&height=120&seq=author-yuan-01&orientation=squarish',
    publishedAt: '2025-07-10',
    readTime: 8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dali%20Yunnan%20scenic%20landscape%20with%20Erhai%20lake%20rice%20fields%20traditional%20white%20architecture%20Cangshan%20mountain%20golden%20sunset%20light%20warm%20cream%20tones%20peaceful&width=1200&height=675&seq=article-travel-02&orientation=landscape',
    tags: ['大理旅拍', '摄影攻略', '云南旅行', '小众景点'],
    featured: false,
    trending: false,
  },
  {
    id: '12',
    slug: 'seasonal-skincare-transition-guide',
    title: '换季护肤急救指南：敏感肌的秋冬过渡方案',
    excerpt: '每到换季，皮肤总是第一个"抗议"。干燥、泛红、起皮——敏感肌的痛苦我们都懂。这份换季护肤急救指南，帮你平稳度过皮肤"叛逆期"。',
    content: [
      '每个敏感肌女孩都懂换季的痛。温差一大、湿度一变，皮肤就开始闹情绪。但是别担心，提前做好准备，就能平稳度过这个"危险期"。',
      '第一步：温和洁面。换季期间皮肤屏障本就脆弱，千万不要再用强力清洁产品了。换成氨基酸洁面，水温控制在32度左右，用手轻轻按摩即可，不要用洁面仪。',
      '第二步：精简护肤流程。换季期间建议把护肤步骤缩减到最基础的"洁面-精华-面霜"三步。尤其是含有酸类、维A类的产品，暂停使用两周。',
      '第三步：加强保湿屏障。神经酰胺、角鲨烷、泛醇——这三个成分是换季期间的"救命稻草"。选择含有这些成分的面霜，厚涂一层当睡眠面膜，第二天起来皮肤会明显舒缓。',
      '第四步：不要忽视身体护理。换季时身体皮肤同样需要关注。洗澡水温不要太热，沐浴后用身体乳锁住水分，尤其是手肘和膝盖这些容易干燥的部位。',
      '皮肤是我们和世界接触的第一道屏障。好好呵护它，它也会回报你的。'
    ],
    category: '美妆护肤',
    categorySlug: 'beauty-skincare',
    author: '桃小美',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Stylish%20young%20Chinese%20woman%20portrait%20with%20natural%20makeup%20warm%20lighting%20peach%20background%20editorial%20quality&width=120&height=120&seq=author-mei-01&orientation=squarish',
    publishedAt: '2025-07-08',
    readTime: 6,
    imageUrl: 'https://readdy.ai/api/search-image?query=Gentle%20skincare%20routine%20products%20ceramide%20cream%20serum%20on%20cream%20background%20with%20soft%20cotton%20flowers%20warm%20soft%20lighting%20clean%20minimal%20editorial%20style&width=1200&height=675&seq=article-beauty-02&orientation=landscape',
    tags: ['换季护肤', '敏感肌', '护肤方案', '皮肤屏障'],
    featured: false,
    trending: false,
  },
];